import { IntegrationRouteSearchSchema } from '@routes/_authenticated/_layout/workspaces/$subscriptionId/integrations/-integrationSearch'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import { CLOUDFLARE_WORKER_METADATA } from 'features/integrations/components/IntegrationMetadata/integrationMetadata'
import { CloudflareFlowPage } from 'features/integrations/pages/CloudflareFlow/CloudflareFlow'
import { CloudflareFlowTab } from 'features/integrations/pages/CloudflareFlow/CloudflareFlowTab'
import { getLDFlag } from 'helpers/launchDarkly'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/integrations/cloudflare-flow/'
)({
  component: Page,
  head: () => {
    return {
      meta: [
        {
          title: withCompanyName(CLOUDFLARE_WORKER_METADATA.title),
        },
      ],
    }
  },
  beforeLoad: async ({ params, context }) => {
    const isFlowStage2Enabled: boolean = getLDFlag('RULESETS_AND_FLOW_STAGE_2', false, context.ldClient)

    if (!isFlowStage2Enabled) {
      throw redirect({ to: AppRoute.IntegrationsActive, params: { subscriptionId: params.subscriptionId } })
    }
  },
  validateSearch: IntegrationRouteSearchSchema,
})

function Page() {
  const { subscriptionId } = Route.useParams()
  const { fromTab } = Route.useSearch()

  return <CloudflareFlowPage activeTab={CloudflareFlowTab.Overview} subscriptionId={subscriptionId} fromTab={fromTab} />
}
